import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=3e0daaf7&scoped=true"
import script from "./Classify.vue?vue&type=script&lang=js"
export * from "./Classify.vue?vue&type=script&lang=js"
import style0 from "./Classify.vue?vue&type=style&index=0&id=3e0daaf7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0daaf7",
  null
  
)

export default component.exports